import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import loadConfig from "../../Services/Api/ApiServices";

const DateInput = (props) => {
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [date, SetDate] = useState(
    props.date ? moment(props.date, "YYYY-MM-DD").toDate() : null
  );

  const dataJson = async () => {
    let jsonData = await loadConfig();
    let fieldsName = props.fieldsName;
    let code = jsonData[fieldsName];
    SetDataJsonObject(code);
  };

  useEffect(() => {
    dataJson();
  }, []);

  // Update date if props.date changes
  useEffect(() => {
    if (props.date) {
      SetDate(moment(props.date, "YYYY-MM-DD").toDate());
    } else {
      SetDate(null);
    }
  }, [props.date]);

  return dataJsonObject ? (
    <>
      <div className="containerInputAHSF">
        <div className="label-container">
          <label htmlFor={dataJsonObject.code} title={dataJsonObject.nameEN}>
            {dataJsonObject.nameAR}
            {dataJsonObject.isRequired ? <span>*</span> : ""}
          </label><span>
          {props.showMassage?
          <p style={{"color":"red"}}>{props.massage}</p>
          :""}
          </span>
          {props.showValidationMessage && (
            <span
              className="validation-icon"
              data-tooltip={props.validationMessage}
            >
              <FontAwesomeIcon icon={faCircleExclamation} />
              &nbsp;
            </span>
          )}
        </div>
        <DatePicker
          selected={date}
          placeholderText="dd/MM/yyyy"
          onChange={(e) => {
            SetDate(e);
            if(props.useFormat==true){

              const formattedDate = moment(e).format("YYYY-MM-DD");
              props.onChange(formattedDate);
            }else{
              props.onChange(e);

            }
          }}
          dateFormat="dd/MM/yyyy"
          minDate={
            new Date(
              dataJsonObject.startDateYear,
              dataJsonObject.startDateMonth,
              dataJsonObject.startDateDay
            )
          }
          maxDate={props.maxDate ? moment(props.maxDate).toDate() : null}
          scrollableYearDropdown
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          className={props.showValidationMessage ? "input-error" : ""}
          autoComplete="off"
          id={props.list ? dataJsonObject.code : "date-post"}
          disabled={props.disabled}
          filterDate={props.filterDate ? (date) => date.getDate() === 1 : ""}
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default DateInput;
